import { ChatMessage, ChatMessageContent, ChatMessageFooter } from "./chat-message";
import { ChatThinkingIndicator } from "./chat-thinking-indicator";

export const ThinkingChatSessionMessage = ({ label }: { label: string }) => {
  return (
    <ChatMessage>
      <ChatMessageContent>
        <ChatThinkingIndicator />
      </ChatMessageContent>
      <ChatMessageFooter>{label}</ChatMessageFooter>
    </ChatMessage>
  );
};
